import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap";
import { isLayer } from "../validator/useLayerIdentity";
import useLogStack from "../../utils/useLogStack";

const store = useWeakMap();
const storeCopySourceToLayer = useWeakMap();

const onDiscardLayer = (layer) => {
    const copySource = useQueryCopySource(layer);
    store.delete(layer);
    storeCopySourceToLayer.delete(copySource);
}

const useQueryCopySource = (layer) => {
    return store.get(layer);
}

export const useQueryLayerByCopySource = (copySource) => storeCopySourceToLayer.get(copySource);

export const storeCopySource = (layer, copySource) => {
    if (store.has(layer)) return;
    if (!isLayer(layer)) new Error('"layer" is not a Layer')
    useLogStack('storeCopySource', layer, copySource);
    store.set(layer, copySource);
    storeCopySourceToLayer.set(copySource, layer);
    useDiscard(layer, onDiscardLayer);
}

export const isCopySource = (source) => storeCopySourceToLayer.has(source);

export default useQueryCopySource